<template>
  <article v-if="image">
    <figure :class="{ 'lg:-mx-6': $route.meta.style === 'db' }">
      <MoleculePicture :image="image" img-class="block w-full rounded-xl" />
      <span v-if="image.source" class="flex justify-end pt-2 text-gray-400 underline text-sm italic font-semibold">
        {{ image.source }}
      </span>
    </figure>
  </article>
</template>

<script setup lang="ts">
interface Props {
  image?: {
    source?: string
  }
}

defineProps<Props>()
</script>
